import { useGetNotices } from 'api/notices';

export function useUnreadUpdatesCount(): number {
    const { data } = useGetNotices();
    return data?.filter((item) => !item.read).length ?? 0;
}
